module.exports = __webpack_public_path__ + "media/8an-sheep.fcdf9aff.mp3";